<template>
  <div class="wifi__content">
    <vs-button type="filled" color="primary" icon="wifi" @click="go">Open WiFi Guest Settings</vs-button>
    <div class="frame">
      <iframe src="https://wifi.smart-english-school.ru/staff"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Wifi Settings',
  methods: {
    go: function(){
      window.open('https://wifi.smart-english-school.ru/staff', '_blank')
    }
  }
  
}
</script>
<style lang="scss">
.frame{
  width: 100%;
  height: 80vh;
  iframe{
    width: 100%;
    height: 100%;
  }
}
</style>
